module.exports = __webpack_public_path__ + "img/hcml_gallery10.7e2b7712.jpg";